module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/141-azerbaijan-435331f74f643d086f651e98b619b417.svg";